import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransportService {

  constructor(private http: CustomHttpService) { }

  // Get all transports with count
  getAllTransportsWithCount(payload: any): Observable<any> {
    return this.http.post(environment.getAllTransportsWithCount, payload);
  }

  // Create transport
  createTransport(payload: any): Observable<any> {
    return this.http.post(environment.createTransport, payload);
  }

  // Update transport
  updateTransport(payload: any): Observable<any> {
    return this.http.post(environment.updateTransport, payload);
  }

  // Delete transport
  deleteTransport(payload: any): Observable<any> {
    return this.http.post(environment.deleteTransport, payload);
  }


  getAllTransports(params: any): Observable<any> {
    return this.http.post(environment.getAllTransportCategories, params);
  }

  // Get transport by ID
  getTransportById(id: number): Observable<any> {
    return this.http.get(`${environment.getTransportById}/${id}`);
  }
}